"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Flows = void 0;
/** @TranslateToPython */
var Flows;
(function (Flows) {
    Flows["origination"] = "origination";
    Flows["pifForAll"] = "pifForAll";
    Flows["statedUsageLanding"] = "statedUsageLanding";
    Flows["hmda"] = "hmda";
    Flows["creditLimitIncrease"] = "creditLimitIncrease";
    Flows["creditLimitIncreaseUcc"] = "creditLimitIncreaseUcc";
    Flows["cliAndAprReductionAndBalanceSweep"] = "cliAndAprReductionAndBalanceSweep";
    Flows["uccOrigination"] = "uccOrigination";
    Flows["mortgageOrigination"] = "mortgageOrigination";
    Flows["firstLienPurchaseOrigination"] = "firstLienPurchaseOrigination";
    Flows["uccSpecialSender"] = "uccSpecialSender";
    Flows["depositOrigination"] = "depositOrigination";
    Flows["uccSpecialOrigination"] = "uccSpecialOrigination";
    Flows["cryptoOrigination"] = "cryptoOrigination";
    Flows["cryptoMachineDemo"] = "cryptoMachineDemo";
    /** Collects applicant data for the legion card waitlist. */
    Flows["legionWaitlist"] = "legionWaitlist";
    /** Handoff flow for applicants originating from partner/TLS flow via JODL. */
    Flows["partnersHandoff"] = "partnersHandoff";
    Flows["_realEstateAgent"] = "realEstateAgent";
})(Flows || (exports.Flows = Flows = {}));
